import { NgModule } from '@angular/core';
import { VendorEditorComponent } from './vendor-editor.component';
import { SharedModule } from '../../../shared/shared.module';
import { GeoRegionSelectorModule } from '../../../shared/geo-region-selector/geo-region-selector.module';
import { ImageEditorModule } from '../../shared/image-editor/image-editor.module';
import { LegfiCurrencyPipeModule } from '../../../../pipes/format/legfi-currency.module';
import { MatDialogModule } from '@angular/material/dialog';
import { LegfiCurrencyPipe } from '../../../../pipes/format/legfi-currency.pipe';
import { NgxMaskModule } from 'ngx-mask';
import { RequiredMessageModule } from '../../shared/required-message/required-message.module';
import { ButtonModule } from '../../../shared/button/button.module';


@NgModule({
    declarations: [
        VendorEditorComponent,
    ],
    imports: [
        SharedModule,
        GeoRegionSelectorModule,
        ImageEditorModule,
        LegfiCurrencyPipeModule,
        MatDialogModule,
        NgxMaskModule.forChild(),
        RequiredMessageModule,
        ButtonModule,
    ],
    providers: [
        // Pipes
        LegfiCurrencyPipe,
    ],
    exports: [
        VendorEditorComponent,
    ],
})
export class VendorEditorCoreModule
{
}
